<template>
  <v-dialog
    :fullscreen="isMobile"
    v-model="internalModelValue"
    width="550px"
  >
    <v-card>
      <v-card-title class="material-preview__header">
        <span>{{ $t('ad-materials.preview.title') }}</span>
        <v-btn
          icon="mdi-close"
          @click="close"
        />
      </v-card-title>
      <v-card-text>
        <r-img :src="material?.previewUrl" />
      </v-card-text>
      <v-card-actions
        :class="{
          'material-preview__actions-padding': isMobile,
        }"
      >
        <v-btn
          color="grey-darken-3"
          @click="close"
          >{{ $t('labels.close') }}</v-btn
        >
        <v-spacer />
        <v-btn :href="material?.previewUrl">
          <v-icon icon="mdi-download" />
          {{ $t('ad-materials.preview.download') }}
        </v-btn>
        <v-btn
          v-if="canCreateContent"
          @click="goToCreateContent"
        >
          <v-icon icon="mdi-brain" />
          {{ $t('ad-materials.preview.create-content') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'

import { AdMaterial } from './index.vue'

type Props = {
  modelValue: string
  material: AdMaterial | null
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const router = useRouter()
const { smAndDown: isMobile } = useDisplay()

const internalModelValue = computed({
  get: () => !!props.modelValue,
  set: () => close(),
})

const canCreateContent = computed(
  () =>
    !!props.material &&
    props.material?.topicId &&
    props.material?.imageSource &&
    props.material.assetType === 'SOCIAL_IMAGE'
)
const close = () => emit('update:modelValue', '')

const goToCreateContent = () => {
  if (!props.material) return
  const { topicId, id: imageId, imageSource } = props.material
  router.push({
    name: 'content-creator',
    hash: '#creator',
    query: { topicId, imageId, imageSource },
  })
  emit('update:modelValue', '')
}
</script>
<style scoped>
.material-preview__header {
  background-color: rgb(var(--v-theme-primary));
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.material-preview__actions-padding {
  padding-bottom: 5rem;
}
</style>
